export default "__VITE_ASSET__67603e8a__"